module.exports = __webpack_public_path__ + "static/partner-hero-c73bcf01bd58ea3a84775db23f9b86c1.png";